import { Image } from '@chakra-ui/react';
import useStore from '@hooks/useStoreMove';
import { fetchRecentOrderedStores } from '@containers/restaurants/queries';
import { useCoreConfig } from 'context/core-config';
import { useTranslation } from 'react-i18next';
import {
  replaceDelivery,
  replaceDeliveryTime,
  replacePrice,
} from 'utils/common';
import StarAvg from '../restaurants/components/star-avg';
import { useSelector } from 'react-redux';
import { addressSelector } from '@stores/address';
import { current } from '@reduxjs/toolkit';

export default function RecentStore() {
  const recentOrderedStore = fetchRecentOrderedStores();
  const { moveRestaurant } = useStore();
  const { margin } = useCoreConfig();
  const { t } = useTranslation('home');
  const { currentAddress } = useSelector(addressSelector);
  return (
    <>
      {recentOrderedStore && recentOrderedStore.length > 0 ? (
        <ul className="flex gap-[30px]">
          {recentOrderedStore.map((store, index) => (
            <li
              key={`recent/${store.id}/${index}`}
              className="flex flex-col cursor-pointer min-w-[240px]"
              onClick={() =>
                moveRestaurant({
                  item: store,
                  category: store.category,
                  queryString: {
                    lat: currentAddress?.lat || '',
                    lng: currentAddress?.lng || '',
                  },
                })
              }
            >
              <Image
                height="120px"
                width="240px"
                src={store.thumbnail_url}
                borderRadius="8px"
              />
              <div className="mt-[10px]">
                <div className="flex items-center justify-between">
                  <p className="truncate font-bold text-[14px]">
                    {store.translate_name || store.name}
                  </p>
                  <p className="text-sm text-secondary-500 whitespace-nowrap">
                    {t('store:estimated_delivery_time', {
                      time: replaceDeliveryTime(
                        store.estimated_delivery_time,
                        '' + t('store:min'),
                      ),
                    })}
                  </p>
                </div>
                <div className="text-secondary-500 text-[12px] flex gap-[12px]">
                  <StarAvg
                    reviewAvg={store.review_avg}
                    reviewCount={store.review_count}
                    direction="horizontal"
                  />
                  <span>{Math.floor(store.distance * 100) / 100}km</span>
                  <span>
                    {t('store:total_delivery_fee')}{' '}
                    {replacePrice(
                      replaceDelivery(
                        // store.delivery_fee_to_display.basic,
                        store.delivery_fee_to_display?.basic || 'Check fee',
                        margin,
                      ),
                      {
                        won: '',
                        free: '0',
                      },
                    )}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>{t('no_recent_orders')}</p>
      )}
    </>
  );
}
